import React from "react";
import { displayIcon } from "variables/icons";
import { 
	MY_ACTAS_USR
} from "variables/modules";

import ActAsUser from "./index";

const actAsUserRoutes = [	
	{
    	name: "Act As User",
	    layout: "/console",
	    path: "act-as-user",
	    icon: displayIcon('User', 'icon-item'),
	    component: <ActAsUser />,
	    isMainMenu:false,
		level:3,
		moduleId: MY_ACTAS_USR,
  	},
]

export default actAsUserRoutes;